import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AdminRoute from './components/AdminRoute';
import AdminOnly from './components/AdminOnly';
import AgentLanding from './components/AgentLanding';
import RequireAgent from './components/RequireAgent';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import OverviewDashboard from './pages/admin/OverviewDashboard';
import DocShawkDocuments from './pages/admin/DocShawkDocuments';
import RunDetail from './pages/admin/RunDetail';
import RunResults from './pages/admin/RunResults';
import Parameters from './pages/admin/Parameters';
import Evals from './pages/admin/Evals';
import Training from './pages/admin/Training';
import Benchmark from './pages/admin/Benchmark';
import Settings from './pages/admin/Settings';
import PipelineDashboard from './pages/admin/PipelineDashboard';
import StageConfig from './pages/admin/StageConfig';
import HelpTrust from './pages/admin/HelpTrust';
import PipelineHub from './pages/admin/PipelineHub';
import Assistant from './pages/admin/Assistant';
import AgentAccess from './pages/admin/AgentAccess';
import AgentConfig from './pages/admin/AgentConfig';
import AgentWorkspace from './pages/admin/AgentWorkspace';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* The DocShawk app (sidebar shell). AdminRoute = must be signed in. */}
          <Route path="/admin" element={<AdminRoute />}>
            <Route element={<AppShell />}>
              {/* Land each user on the first agent they're permitted to use. */}
              <Route index element={<AgentLanding />} />

              {/* Doc-agent surfaces — gated on doc access. */}
              <Route element={<RequireAgent agentKey="doc"><Outlet /></RequireAgent>}>
                <Route path="docshawk" element={<DocShawkDocuments />} />
                <Route path="docshawk/runs/:runId" element={<RunDetail />} />
                <Route path="docshawk/runs/:runId/schema" element={<RunDetail />} />
                <Route path="docshawk/runs/:runId/review" element={<RunDetail />} />
                <Route path="docshawk/runs/:runId/results" element={<RunResults />} />
                <Route path="assistant" element={<Assistant />} />
                <Route path="parameters" element={<Parameters />} />
                <Route path="help" element={<HelpTrust />} />
              </Route>

              {/* Agent-scoped hubs (marketing / jira / …). RequireAgent enforced inside. */}
              <Route path="agent/:agentKey" element={<AgentWorkspace />} />
              <Route path="agents/:agentKey/config" element={<AgentConfig />} />

              {/* Admin / ML-ops only. */}
              <Route element={<AdminOnly />}>
                <Route path="overview" element={<OverviewDashboard />} />
                <Route path="evals" element={<Evals />} />
                <Route path="training" element={<Training />} />
                <Route path="benchmark" element={<Benchmark />} />
                <Route path="settings" element={<Settings />} />
                <Route path="config" element={<StageConfig />} />
                <Route path="config/:stage" element={<StageConfig />} />
                <Route path="pipeline" element={<PipelineDashboard />} />
                <Route path="pipeline-hub" element={<PipelineHub />} />
                <Route path="agent-access" element={<AgentAccess />} />
              </Route>
            </Route>
          </Route>

          {/* Everything else → the app landing (AdminRoute bounces unauthenticated users to /login). */}
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
